import { create } from "zustand";
import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export const SIDEBAR_VIEWS = Object.freeze({
  CHAT: "CHAT",
  PARTICIPANTS: "PARTICIPANTS",
});

interface PublicLiveStoreState {
  actions: {
    setIsGuestPromptOpen: (isGuestPromptOpen: boolean) => void;
    toggleGuestPrompt: () => void;
    hideSidebar: () => void;
    setChatSidebar: () => void;
    setParticipantsSidebar: () => void;
    toggleChatSidebar: () => void;
    toggleParticipantsSidebar: () => void;
    toggleInfoBox: () => void;
    setGuestName: (name: string) => void;
    leaveStream: () => void;
    setIsFullscreen: (isFullscreen: boolean) => void;
  };
  guest: {
    name: string;
  };
  hasLeftStream: boolean;
  isFullscreen: boolean;
  isGuestPromptOpen: boolean;
  isInfoBoxOpen: boolean;
  sidebarView: (typeof SIDEBAR_VIEWS)[keyof typeof SIDEBAR_VIEWS] | null;
}

export const usePublicLiveStore = create<PublicLiveStoreState>()(
  persist(
    immer(set => ({
      sidebarView: SIDEBAR_VIEWS.CHAT,
      isGuestPromptOpen: true,
      guest: {
        name: "",
      },
      hasLeftStream: false,
      isInfoBoxOpen: false,
      isFullscreen: false,
      actions: {
        setIsGuestPromptOpen: isGuestPromptOpen =>
          set(state => {
            state.isGuestPromptOpen = isGuestPromptOpen;
          }),
        toggleGuestPrompt: () =>
          set(state => {
            state.isGuestPromptOpen = !state.isGuestPromptOpen;
          }),
        hideSidebar: () =>
          set(state => {
            state.sidebarView = null;
          }),
        setChatSidebar: () =>
          set(state => {
            state.sidebarView = SIDEBAR_VIEWS.CHAT;
          }),
        setParticipantsSidebar: () =>
          set(state => {
            state.sidebarView = SIDEBAR_VIEWS.PARTICIPANTS;
          }),
        toggleChatSidebar: () =>
          set(state => {
            if (state.sidebarView === SIDEBAR_VIEWS.CHAT) {
              state.sidebarView = null;
            } else {
              state.sidebarView = SIDEBAR_VIEWS.CHAT;
            }
          }),
        toggleParticipantsSidebar: () =>
          set(state => {
            if (state.sidebarView === SIDEBAR_VIEWS.PARTICIPANTS) {
              state.sidebarView = null;
            } else {
              state.sidebarView = SIDEBAR_VIEWS.PARTICIPANTS;
            }
          }),
        toggleInfoBox: () =>
          set(state => {
            state.isInfoBoxOpen = !state.isInfoBoxOpen;
          }),
        setGuestName: name =>
          set(state => {
            state.guest.name = name;
          }),
        leaveStream: () =>
          set(state => {
            state.hasLeftStream = true;
          }),
        setIsFullscreen: isFullscreen =>
          set(state => {
            state.isFullscreen = isFullscreen;
          }),
      },
    })),
    {
      name: "circle-public-live-storage",
      version: 0,
      partialize: state => ({
        guest: state.guest,
      }),
    },
  ),
);
